import PrivateLayout from '@/layouts/PrivateLayout.vue';
import PhotoStats from '@/pages/reports/PhotoStats.vue';
import SmartRevenueAnalytics from '@/pages/reports/SmartRevenueAnalytics.vue';

export default [
  {
    path: '/reports',
    component: PrivateLayout,
    meta: { requiresAuth: true, roles: ['superuser', 'user'] },
    children: [
      {
        path: 'photo-stats',
        name: 'PhotoStats',
        component: PhotoStats,
      },
      {
        path: 'revenue-analytics',
        name: 'RevenueAnalytics',
        component: SmartRevenueAnalytics,
      },
    ],
  },
];
